import { INIT_UI, SHOW_SELECTOR, CLOSE_SELECTOR, SELECT_ITEM} from '../actions/types'
import {STARTLIST } from '../util/consts'

const initialState = {
    currEventID: null
}

export default function( state = initialState, action){
    switch( action.type){

        case INIT_UI: 
            return {
                ...state
                , showList: STARTLIST
            }
        case SHOW_SELECTOR: 
            return {
                ...state
                , activeSelector: action.payload
            }
        case CLOSE_SELECTOR: 
            return {
                ...state
                , activeSelector: null
            }
        case SELECT_ITEM: 
            return {
                ...state
                , activeSelector: null
            }

        default : 
            return state
    }
}